var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "gantt-pagination" },
    [
      _c("el-pagination", {
        attrs: {
          background: "",
          layout: "sizes, total, prev, pager, next",
          "current-page": _vm.tCurrentPage,
          "page-size": _vm.tPageSize,
          "page-sizes": [10, 20],
          total: _vm.isUpdateBufferTrucks["hasValue"]
            ? _vm.filteredTrucks.length
            : _vm.$trucks.length,
        },
        on: {
          "size-change": function ($event) {
            return _vm.handlePagination($event, "sizeChange")
          },
          "current-change": function ($event) {
            return _vm.handlePagination($event, "currentChange")
          },
        },
      }),
      _c(
        "el-row",
        { staticClass: "ml-2 mt-2", attrs: { type: "flex" } },
        [
          _c("el-col", { attrs: { xs: 24 } }, [
            _vm._v(
              " " +
                _vm._s(_vm.$t("planning.totalTravelDistance")) +
                ": " +
                _vm._s(_vm.totalTravelDistance) +
                " "
            ),
          ]),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }